import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Row, Col, Button, Spinner, Badge } from "reactstrap";
import { toast } from 'react-toastify';
import { formattedDate } from "../../helpers/Helper";
import userServices from "../../services/user.services";
import a from '../../assets/images/avatars/avatar-1.png'

const UserInfoPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getUserInfo();
    }, [id]);

    const getUserInfo = async () => {
        try {
            const result = await userServices.getUserInfo(id);
            if (result.status === 200 && result.data.status === true) {
                const userData = result.data.user_details;
                const bookings = result.data.booking_details || [];

                setUserDetails({
                    user_id: userData._id,
                    user_name: userData.name || 'N/A',
                    user_email: userData.email || 'N/A',
                    user_mobile: userData.mobile || 'N/A',
                    user_gender: userData.gender || 'N/A',
                    user_address: userData.address || 'N/A',
                    profile_img: userData.profile_img || null,
                    user_status: userData.user_status,
                    created_at: userData.created_at,
                    totalBookings: bookings.length,
                    bookings: bookings
                });
            } else {
                toast.error('No user information found');
            }
        } catch (error) {
            console.log('error', error);
            toast.error('Error loading user information');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!userDetails) {
        return (
            <div className="page-wrapper">
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <div className="text-center" style={{ minHeight: '400px', paddingTop: '100px' }}>
                            <i className="bx bx-user-x" style={{ fontSize: '4rem', color: '#ccc' }}></i>
                            <h4 className="mt-3">User information not found</h4>
                            <Button color="primary" className="mt-3" onClick={() => navigate(-1)}>
                                <i className="bx bx-arrow-back me-1"></i>
                                Go Back
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="page-wrapper">
                <div className="page-content-wrapper">
                    <div className="page-content">
                        {/* Breadcrumb */}
                        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                            <div className="ps-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb mb-0 p-0">
                                        <li className="breadcrumb-item">

                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            User Information
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="ms-auto">
                                <div className="btn-group">
                                    <Button color="outline-primary" size="sm" onClick={() => navigate(-1)}>
                                        <i className="bx bx-arrow-back me-1"></i>
                                        Back
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* User Info Card */}
                        <Row>
                            <Col lg={4}>
                                <Card className="radius-15">
                                    <div className="card-body text-center">
                                        <div className="p-4">
                                            <div className="d-flex justify-content-center mb-3">
                                                {userDetails.profile_img ? (
                                                    <img
                                                        src={a}
                                                        alt="Profile"
                                                        className="user-img"
                                                        style={{
                                                            width: '120px',
                                                            height: '120px',
                                                            borderRadius: '50%',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                ) : (
                                                    <div style={{
                                                        width: '120px',
                                                        height: '120px',
                                                        borderRadius: '50%',
                                                        background: 'linear-gradient(180deg, #FF7B00 0%, #FF3700 100%)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '3.5rem',
                                                        color: 'white'
                                                    }}>
                                                        <i className="lni lni-user"></i>
                                                    </div>
                                                )}
                                            </div>
                                            <h4 className="mb-1">{userDetails.user_name}</h4>
                                            <p className="text-muted mb-1" style={{ fontSize: '0.9rem' }}>
                                                <i className="lni lni-user me-1"></i>
                                                {userDetails.user_gender}
                                            </p>
                                            <hr className="my-3" />
                                            <div className="text-start">
                                                <p className="mb-2">
                                                    <i className="lni lni-envelope me-2 text-primary"></i>
                                                    <small>{userDetails.user_email}</small>
                                                </p>
                                                <p className="mb-2">
                                                    <i className="lni lni-phone me-2 text-primary"></i>
                                                    <small>{userDetails.user_mobile}</small>
                                                </p>
                                                <p className="mb-2">
                                                    <i className="lni lni-map-marker me-2 text-primary"></i>
                                                    <small>{userDetails.user_address}</small>
                                                </p>
                                                <p className="mb-2">
                                                    <i className="lni lni-calendar me-2 text-primary"></i>
                                                    <small>Member since {formattedDate(userDetails.created_at)}</small>
                                                </p>
                                            </div>
                                            <hr className="my-3" />
                                            <div className="d-flex justify-content-around">
                                                <div>
                                                    <Badge color={userDetails.user_status === 1 ? 'success' : 'secondary'} pill className="px-3 py-2">
                                                        {userDetails.user_status === 1 ? 'Active' : 'Inactive'}
                                                    </Badge>
                                                </div>
                                                <div>
                                                    <Badge color="primary" pill className="px-3 py-2">
                                                        <i className="lni lni-calendar me-1"></i>
                                                        {userDetails.totalBookings} Bookings
                                                    </Badge>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>

                                <Card className="radius-15">
                                    <div className="card-header">
                                        <h6 className="mb-0">Quick Actions</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-grid gap-2">
                                            <Button
                                                color="primary"
                                                onClick={() => navigate(`/user/bookings/${id}`)}
                                            >
                                                <i className="lni lni-calendar me-2"></i>
                                                View All Bookings
                                            </Button>
                                        </div>
                                    </div>
                                </Card>
                            </Col>

                            <Col lg={8}>
                                <Card className="radius-15">
                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            <i className="lni lni-calendar me-2"></i>
                                            Recent Bookings
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {userDetails.bookings && userDetails.bookings.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-striped align-middle table-nowrap">
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th>Booking ID</th>
                                                            <th>Patient Name</th>
                                                            <th>X-ray Type</th>
                                                            <th>Booking Date</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userDetails.bookings.slice(0, 5).map((booking, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <span className="badge bg-light text-dark">
                                                                        {booking.xray_booking_id}
                                                                    </span>
                                                                </td>
                                                                <td>{booking.patent_name}</td>
                                                                <td>{booking.xray_type_name}</td>
                                                                <td>{formattedDate(booking.booking_date)}</td>
                                                                <td>
                                                                    <span
                                                                        onClick={() => navigate(`/view-booking-detail/${booking._id}`)}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <i className="lni lni-eye font-size-16"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {userDetails.bookings.length > 5 && (
                                                    <div className="text-center mt-3">
                                                        <Button
                                                            color="link"
                                                            onClick={() => navigate(`/user/bookings/${id}`)}
                                                        >
                                                            View All {userDetails.totalBookings} Bookings
                                                            <i className="lni lni-arrow-right ms-1"></i>
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="text-center py-5">
                                                <i className="lni lni-calendar" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                                                <p className="text-muted mt-2">No bookings found</p>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UserInfoPage;
